import type { DeviceJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectDevice extends IkeRestObject<DeviceJSONObject> {
	className = 'Device' as const;
	actionName = 'device';
	object: DeviceJSONObject;

	constructor() {
		super();
		this.cacheKeys['deviceId'] = true;
	}
}
